import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Beneficios.css';

function Beneficios() {
  const benefitsList = [
    {
      id: 1,
      title: 'Aroma y Bienestar Terapéutico',
      desc: 'El aroma dulce y cálido de la vainilla natural posee propiedades relajantes comprobadas que reducen el estrés, elevan el estado de ánimo y aportan una sensación integral de serenidad.',
      image: '/aroma.jpeg',
      icon: '🍃',
    },
    {
      id: 2,
      title: 'Fuente Natural de Antioxidantes',
      desc: 'La vainilla pura contiene potentes polifenoles y vainillina activa que combaten los radicales libres, protegiendo las células y respaldando la vitalidad del organismo.',
      image: '/antioxidantes.jpeg',
      icon: '🧪',
    },
    {
      id: 3,
      title: '100% Pura y Libre de Sintéticos',
      desc: 'Nuestra vainilla 100% costarricense se cultiva sin aditivos ni aromatizantes artificiales, ofreciendo un sabor limpio, auténtico y de máxima concentración botánica.',
      image: '/vainillapura.jpeg',
      icon: '🌱',
    },
    {
      id: 4,
      title: 'Versatilidad Gourmet en Cocina',
      desc: 'Desde alta repostería y bebidas artesanales hasta salsas sofisticadas para carnes y mariscos, la vainilla aporta una complejidad y elegancia inigualables.',
      image: '/versatilidad.jpeg',
      icon: '🍽️',
    },
  ];

  return (
    <div className="beneficios-page">
      <Helmet>
        <title>Beneficios de la Vainilla Natural | Sol de Vainilla</title>
        <meta
          name="description"
          content="Descubra las propiedades antioxidantes, relajantes y gastronómicas de la vainilla 100% costarricense de Sol de Vainilla."
        />
      </Helmet>

      {/* Hero */}
      <section
        className="beneficios-hero"
        style={{
          backgroundImage:
            "radial-gradient(circle at center, rgba(14, 25, 12, 0.7) 0%, rgba(10, 18, 9, 0.92) 100%), url('/field1.jpeg')",
        }}
      >
        <div className="container">
          <span className="beneficios-badge">Propiedades y Bienestar</span>
          <h1>Beneficios de la Vainilla</h1>
          <p>
            Más allá de su exquisito sabor y aroma, la vainilla natural es un tesoro botánico con amplias aplicaciones terapéuticas, nutricionales y culinarias.
          </p>
        </div>
      </section>

      {/* Cards Section */}
      <section className="beneficios-main-section">
        <div className="container">
          <div className="beneficios-header-text">
            <span className="section-kicker">CON VAINILLA SIEMPRE SÍ!!</span>
            <h2>¿Por Qué Elegir Vainilla 100% Costarricense?</h2>
          </div>

          <div className="beneficios-cards-grid">
            {benefitsList.map((item) => (
              <div className="beneficio-card-item" key={item.id}>
                <div className="beneficio-card-img-box">
                  <img src={item.image} alt={item.title} />
                  <span className="beneficio-icon-tag">{item.icon}</span>
                </div>
                <div className="beneficio-card-body">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom Action Banner */}
          <div className="beneficios-cta-box">
            <div className="beneficios-cta-content">
              <h3>Disfrute la autenticidad de nuestra vainilla</h3>
              <p>Explore nuestro catálogo de productos o consulte sobre asesoría en plantaciones sostenibles.</p>
            </div>
            <div className="beneficios-cta-buttons">
              <Link to="/productos" className="cta-gold-btn">Ver Nuestros Productos</Link>
              <Link to="/servicios" className="cta-outline-btn">Asesoría</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Beneficios;